// extracted by mini-css-extract-plugin
export default {"Box":"BlameAgeLegend-module__Box--dTotP","Text":"BlameAgeLegend-module__Text--qfxJQ","Box_1":"BlameAgeLegend-module__Box_1--n0gaX","Text_1":"BlameAgeLegend-module__Text_1--Ifgnh"};